import { Injectable } from '@angular/core'
import { RoutingService } from '@spartacus/core'
import { OrderDetailsService } from '@spartacus/order/components'
import { OrderHistoryService } from '@spartacus/order/core'
import { OrderFacade } from '@spartacus/order/root'
import { UnitOrderService } from '@spartacus/organization/unit-order/core'
import { saveAs } from 'file-saver'
import { combineLatest, Observable, of } from 'rxjs'
import { distinctUntilChanged, map, shareReplay, switchMap, tap } from 'rxjs/operators'
import { EbUserIdService } from '../../../auth/services/eb-user-id.service'
import { EbLanguageService } from '../../../site-context/services/eb-language.service'
import { EbUserAccountService } from '../../../user/services/eb-user-account.service'
import { EbOrder } from '../../interfaces/eb-order.interface'
import { EbOrderAdapter } from '../connectors/eb-order.adapter'

@Injectable({
  providedIn: 'root'
})
export class EbOrderDetailsService extends OrderDetailsService {
  constructor(
    routingService: RoutingService,
    protected ebRoutingService: RoutingService,
    protected ebUserOrderService: OrderFacade,
    protected userIdService: EbUserIdService,
    protected userAccountService: EbUserAccountService,
    protected orderAdapter: EbOrderAdapter,
    protected languageService: EbLanguageService,
    protected unitOrderService: UnitOrderService,
    orderHistoryService: OrderHistoryService
  ) {
    super(orderHistoryService, routingService)
    this.orderCode$ = this.ebRoutingService.getRouterState().pipe(
      map(routingData => {
        if (routingData.state.params.orderCode) {
          return routingData.state.params.orderCode
        } else {
          return routingData.state.url.split('/').pop()
        }
      }),
      distinctUntilChanged()
    )

    this.orderLoad$ = combineLatest([this.languageService.getActive(), this.orderCode$]).pipe(
      tap(([, orderCode]) => {
        if (orderCode) {
          this.unitOrderService.loadOrderDetails(orderCode)
        } else {
          this.unitOrderService.clearOrderDetails()
        }
      }),
      shareReplay({ bufferSize: 1, refCount: true })
    )
  }

  override getOrderDetails(): Observable<EbOrder> {
    return combineLatest([this.languageService.getActive(), this.orderLoad$]).pipe(
      switchMap(() => this.ebUserOrderService.getOrderDetails()),
      switchMap(order => of(order as EbOrder))
    )
  }

  downloadDocument(documentId: string, fileName: string) {
    combineLatest([this.userIdService.getUserId(), this.userAccountService.getEbActiveUserData()])
      .pipe(
        switchMap(([userId, userData]) => {
          return this.orderAdapter.downloadOrderDocument(userId, userData?.orgUnit?.uid, documentId)
        })
      )
      .subscribe(document => {
        saveAs(document, fileName, { autoBom: false })
      })
  }
}
